import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import { refreshTrueFitWidget } from 'utilities/truefit/truefit';

const TrueFitContainer = styled.div`
  display: flex;
  align-items: center;
  min-height: 56px;
  margin-bottom: var(--spacing-space16);
`;

interface TrueFitWidgetProps {
  itemNumber: string;
  colour: string;
  locale: string;
  userId: string;
}

function TrueFitWidget({ itemNumber, colour, locale, userId }: TrueFitWidgetProps) {
  const { selectedOptions } = useSelectedSkuContext();
  const { colour: selectedColour } = selectedOptions;

  useEffect(() => {
    if (selectedColour || userId) {
      refreshTrueFitWidget();
    }
  }, [selectedColour, userId]);

  return (
    <TrueFitContainer
      className="tfc-fitrec-product"
      data-styleid={itemNumber}
      data-userid={userId}
      data-colorid={selectedColour || colour}
      data-locale={locale}
      data-testid="truefit_widget_container"
    />
  );
}

export default TrueFitWidget;
